<div class="p-inputgroup basin-mb-2">
  <span *ngIf="inputLeftAddonText" class="p-inputgroup-addon addon-left">
    {{ inputLeftAddonText }}
  </span>
  <input
    pInputText
    [type]="inputType"
    [ngClass]="getInputBorderRadius()"
    [(ngModel)]="ngModel.inputValue"
    (ngModelChange)="selectorValueChange($event)"
    (focus)="focus()"
    (blur)="blur()"
    autocomplete="off"
    [class]="inputStyleClass"
    [id]="inputId"
    [name]="inputName"
    [placeholder]="inputPlaceholder ?? ''"
    [minlength]="inputMinlength"
    [maxlength]="inputMaxlength"
    [readonly]="inputReadonly"
    [required]="inputRequired"
    [disabled]="inputDisabled"
  />
  <span *ngIf="inputRightAddonText" class="p-inputgroup-addon addon-right">
    {{ inputRightAddonText }}
  </span>
</div>

<p-selectButton
  class="basin-frequency-select-button"
  [(ngModel)]="ngModel.selectorValue"
  (ngModelChange)="selectorValueChange($event)"
  [options]="selectorOptions"
  [optionLabel]="selectorOptionLabel"
  [optionValue]="selectorOptionValue"
  [optionDisabled]="selectorOptionDisabled"
  [unselectable]="selectorUnselectable"
  [tabindex]="selectorTabindex"
  [multiple]="selectorMultiple"
  [allowEmpty]="selectorAllowEmpty"
  [style]="selectorStyle"
  [styleClass]="selectorStyleClass"
  [disabled]="selectorDisabled"
  [dataKey]="selectorDataKey"
  [autofocus]="selectorAutofocus"
></p-selectButton>
